import React, {ChangeEvent, useEffect, useState} from "react";
import Box from "@mui/material/Box";
import {
    Button,
    FormControl,
    Grid, InputBase,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    SelectChangeEvent,
    Typography
} from "@mui/material";
import {DataTable} from "../components/DataTable";
import { Icon } from '@iconify/react';
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import IconButton from "@mui/material/IconButton";
import {Model} from "../components/Model";
import {ExportTable} from "../components/ModelComponents/ExportTable";
import {RoutesList} from "../Modules/RoutesList";
import {useNavigate} from "react-router-dom";
import services from "../services";
// import {DevicesData} from "./Dashboard";
import {DataGrid, GridColDef, GridColumns, GridValueGetterParams} from "@mui/x-data-grid";
import Skeleton from "@mui/material/Skeleton";
import {useSelector} from "react-redux";
import {RootState} from "../app/store";


interface Device {
    id:number,
    deviceId:string,
    category:string,
    created_at:Date,
    alias:string,
    // UserDevices:any
}

interface DevicesData {
    id:number,
    name:string,
    logo:string,
}





var orignalTableData : any = [];

export const Analytics = () =>{
    const auhUser = useSelector(((state:RootState) => state.auth.user))
    const [model,setModel] = useState<boolean>(false)
    const handleOpen = () => setModel(true)
    const handleClose = () => setModel(false)
    const [alldevices,setallDevices] = useState<Device[]>([])
    const [perPage, setPerPage] = React.useState<number>(10);
    const [categories,setCategories] = useState<DevicesData[]>([])
    const [devices,setDevices] = useState<Device[]>([])
    const [startDate,setStartDate] = useState<string>(new Date().toISOString().split('T')[0])
    const [endDate,setEndDate] = useState<string>(new Date().toISOString().split('T')[0])
    const [currentCategory,setCurrentCategory] = useState<string>('')
    const [currentDevice,setCurrentDevice] = useState<string>('')
    const [tableData , setTableData] = useState<any>([])

    const [columns,setColumns] = useState<GridColumns>([])

    const [searchKey,setSearchKey] = useState<string>('')

    const [tableskeleton,setTableSkeleton] = useState<boolean>(true)

    const duration =''

    const columnstwo  : GridColumns = [
        // {field: "id", headerName: "ReadingID", minWidth: 100, flex: 1,align: 'center',headerAlign: 'center'},
        // {field: duration?duration:"", headerName: duration, minWidth: 100, flex: 1,align: 'center',headerAlign: 'center'},
        // {field: "Diastolic", headerName: "Diastolic", minWidth: 100, flex: 1,align: 'center',headerAlign: 'center'},
        // {field: "Systolic", headerName: "Systolic", minWidth: 100, flex: 1,align: 'center',headerAlign: 'center'},
        // {field: "Pulse", headerName: "Pulse", minWidth: 100, flex: 1,align: 'center',headerAlign: 'center'},
    ]


    const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
        setPerPage(+event.target.value);
    };


    const handleSearch = (keyword : string) =>{


      let search_result = tableData.filter((o : any) => (JSON.stringify(o)).includes(keyword))
      setTableData(search_result)


        if(keyword.length===0)
        {
            setTableData(orignalTableData)
        }
    }



    const navigator = useNavigate()
    const token = localStorage.getItem("token")
    useEffect(()=>{
        if(!token)
            navigator(RoutesList.Login.path)
    },[])

    useEffect(()=>{
        let devices = JSON.parse(localStorage.getItem("devices")!)
        let categories = JSON.parse(localStorage.getItem("categories")!)
        setCategories(categories)
        setallDevices(devices)
        if(devices.length>0)
        setDevices(devices.filter((d:any)=>d.category === categories[0].name))
    },[])

    useEffect(()=>{
        if(categories.length>0 && alldevices.length>0)
            fetchReadings()
        else
            setTableSkeleton(false)
    },[startDate,endDate,currentCategory,currentDevice,categories])

    const fetchReadings = () =>{
        setTableSkeleton(true)
        let category = ''
        if(currentCategory.length>0)
            category = currentCategory === "Blood Pressure" ? "bp" : "spo2"
        else
            category = categories[0].name === "Blood Pressure" ? "bp" : "spo2"

        let _imei = ''
        if(currentDevice.length>0)
            _imei = currentDevice
        else
            _imei = alldevices[0].deviceId


        services.getReadings({
            startDate: startDate,
            endDate: endDate,
            imei :_imei,
            category_name:currentCategory.length>0?currentCategory:categories[0].name,
            timeZone : -(new Date().getTimezoneOffset() / 60),
            userID : auhUser.userID
            },
        )
            .then(e=>{

                let _col : GridColumns = []
                Object.keys(e.data.readings[0]).map((r:string)=>{
                    _col.push({field: r, headerName: r, minWidth: 110, flex: 1,align: 'center',headerAlign: 'center'})
                })

                setColumns(_col)

                // {field: "id", headerName: "ReadingID", minWidth: 110, flex: 1,align: 'center',headerAlign: 'center'}

                setTableData(e.data.readings)
                setTableSkeleton(false)
                setTableSkeleton(false)
            })
            .catch(e=>{
                setTableSkeleton(false)
            })
    }

    const modelComponent = ()=>{
        return (
            <ExportTable />
        )
    }

    const handleDevicesDropDown = (e : string) =>{
        console.log('devices',e)
           setCurrentDevice(e)
            // fetchReadings(e)
    }

    const handleCategoryDropDown = (name:string) =>{
        setCurrentCategory(name)
        setDevices(devices.filter(d=>d.category === name))
    }

    return (
        <Box sx={{ flexGrow: 1,padding:"0px 30px" }}>
            {/*<Model*/}
            {/*    open={model}*/}
            {/*    handleClose={handleClose}*/}
            {/*    Component = {modelComponent}*/}
            {/*/>*/}
            <Typography
                fontSize={32}
                fontWeight={700}
                color="#081735"
                paddingTop={1}
                paddingBottom={4}
            >
                Analytics
            </Typography>


            <Grid
                marginTop={3}
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                flexWrap="nowrap"
            >


                <Grid container item spacing={5}>
                    <Grid item xs="auto">
                        <Typography>
                            From
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DesktopDatePicker
                                label="Custom input"
                                value={startDate}
                                onChange={(newValue) => {
                                    let ISOstring = new Date(newValue!).toISOString()
                                    setStartDate(ISOstring.split('T')[0]!);
                                }}
                                renderInput={({ inputRef, inputProps, InputProps }) => (
                                    <Box sx={{ display: 'flex', alignItems: 'center',background:"#FFFFFF",padding:"0px 10px",borderRadius:"12px",height:"40px"}}>
                                        <input ref={inputRef} {...inputProps} style={{border:"none"}} />
                                        {InputProps?.endAdornment}
                                    </Box>
                                )}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={"auto"}>
                        <Typography>
                            To
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DesktopDatePicker
                                label="Custom input"
                                minDate={new Date(startDate)}
                                value={endDate}
                                onChange={(newValue) => {
                                    let ISOstring = new Date(newValue!).toISOString()
                                    setEndDate(ISOstring.split('T')[0]!);
                                    setEndDate(ISOstring.split('T')[0]!);
                                }}
                                renderInput={({ inputRef, inputProps, InputProps }) => (
                                    <Box sx={{ display: 'flex', alignItems: 'center',background:"#FFFFFF",padding:"0px 10px",borderRadius:"12px",height:"40px"}}>
                                        <input ref={inputRef} {...inputProps} style={{border:"none"}} />
                                        {InputProps?.endAdornment}
                                    </Box>
                                )}
                            />
                        </LocalizationProvider>
                    </Grid>
                </Grid>


                <Grid container item justifyContent="flex-end">
                    <Grid item xs={7}>
                        <Paper
                            component="form"
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                border:"1px solid #0096C7",
                                background:"none",
                                borderRadius:"20px",
                                boxShadow:"none",
                                width:"100%"
                            }}
                        >
                            <InputBase
                                sx={{ ml: 1, flex: 1, }}
                                onChange={e=>handleSearch(e.target.value)}
                                placeholder="Type here..."
                                inputProps={{ 'aria-label': 'search google maps' }}
                            />
                            <IconButton type="submit" sx={{ p: '10px' }} aria-label="search">
                                <Icon icon="ant-design:search-outlined" color="#0096C7" style={{borderRadius:"10px"}} />
                            </IconButton>
                        </Paper>
                    </Grid>
                </Grid>
            </Grid>


            <Grid
                marginTop={3}
                marginBottom={3}
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                flexWrap="nowrap"
            >


                <Grid container item spacing={4}>
                    <Grid item xs="auto">
                            <span style={{fontSize:"16px",color:"#34335B",marginRight:"20px"}}>Show</span>
                        <select
                            style={{
                                border:"none",
                                background:"#F9FAFC",
                                padding:"10px",
                                borderRadius:"15px"
                            }}
                            value={perPage.toString()}
                            onChange={handleChange}
                        >
                            <option value={10}>10</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </select>
                    </Grid>
                    <Grid item xs={"auto"}>
                        <select
                            style={{
                                border:"none",
                                background:"#F9FAFC",
                                padding:"10px",
                                borderRadius:"15px"
                            }}
                            // value={"All Categories"}
                            onChange={(e)=>{handleCategoryDropDown(e.target.value)}}
                        >
                            {
                                categories.map(e=>(
                                    <option value={e.name} key={e.name}>{e.name}</option>
                                ))
                            }
                        </select>
                    </Grid>
                    <Grid item xs={"auto"}>
                        {
                            devices.length>1?
                                <select
                                    style={{
                                        border:"none",
                                        background:"#F9FAFC",
                                        padding:"10px",
                                        borderRadius:"15px"
                                    }}
                                    // value={"All Categories"}
                                    onChange={(e)=>{handleDevicesDropDown(e.target.value)}}
                                >
                                    {
                                        devices.map(e=>(
                                            <option value={e.deviceId} key={e.id}>{e.alias}</option>
                                        ))
                                    }
                                </select>
                                :''
                        }
                    </Grid>
                </Grid>


                {/*<Grid container item spacing={4} justifyContent="flex-end">*/}
                {/*    <Grid item xs={"auto"}>*/}
                {/*        <Button*/}
                {/*            onClick={handleOpen}*/}
                {/*            variant="contained"*/}
                {/*            sx={{*/}
                {/*                borderRadius:"16px",*/}
                {/*                background:"#0096C7",*/}
                {/*                textTransform:"none",*/}
                {/*                color:"#F9FAFC",*/}
                {/*                fontWeight:700,*/}
                {/*                fontSize : "16px"*/}
                {/*            }}> <Icon icon="ic:baseline-download" color="#F9FAFC" /> &nbsp; Export</Button>*/}
                {/*    </Grid>*/}
                {/*</Grid>*/}
            </Grid>

            <DataTable showFooter={true} perPage={perPage} data={tableData} height = {650} skeleton={tableskeleton} columns={columns}/>
        </Box>
    )
}